import * as actionTypes from 'js/constants/actionTypes';
import { CALL_PRIVATE_API } from 'js/constants/api';
import { DELETE, GET, POST, PUT } from 'js/constants/requestMethods';
import { isEmpty } from 'lodash';
import { FlowLinksInput, FlowTriggersInput } from 'new/state/flowTriggers/types';

export function deleteTriggers(sourceId: number, idsToDelete: number[]) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DELETE_FLOW_TRIGGERS_REQUEST,
          actionTypes.DELETE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.DELETE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/data_sources/${sourceId}/flow_triggers`,
        requestMethod: DELETE,
        payload: {
          flow_triggers: idsToDelete,
        },
      },
    });
  };
}

export function deleteLinks(flow_node_id: number, payload: any) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DELETE_FLOW_TRIGGERS_REQUEST,
          actionTypes.DELETE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.DELETE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/flows/${flow_node_id}/links`,
        requestMethod: DELETE,
        payload,
      },
    });
  };
}

export function deleteAllLinks(flow_node_id: number) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.DELETE_FLOW_TRIGGERS_REQUEST,
          actionTypes.DELETE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.DELETE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/flows/${flow_node_id}/links/all`,
        requestMethod: DELETE,
      },
    });
  };
}

/** A source's triggers as the API has them now (both directions). */
export function loadTriggers(sourceId: number) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.LOAD_FLOW_TRIGGERS_REQUEST,
          actionTypes.LOAD_FLOW_TRIGGERS_SUCCESS,
          actionTypes.LOAD_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/data_sources/${sourceId}/flow_triggers`,
        requestMethod: GET,
      },
    });
  };
}

/** Adds triggers to a source, leaving its existing ones (and their status) untouched. */
export function addTriggers(sourceId: number, flow_triggers: FlowTriggersInput) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.CREATE_FLOW_TRIGGERS_REQUEST,
          actionTypes.CREATE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.CREATE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/data_sources/${sourceId}/flow_triggers`,
        requestMethod: PUT,
        payload: {
          flow_triggers,
        },
      },
    });
  };
}

/** Replaces ALL of a source's inbound triggers (API `reset`). */
export function createTriggers(
  sourceId: number,
  flow_triggers: FlowTriggersInput | FlowLinksInput,
) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.CREATE_FLOW_TRIGGERS_REQUEST,
          actionTypes.CREATE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.CREATE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/data_sources/${sourceId}/flow_triggers`,
        requestMethod: POST,
        payload: {
          flow_triggers,
        },
      },
    });
  };
}

export function createLinks(flow_node_id: number, payload: any) {
  return (dispatch) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.CREATE_FLOW_TRIGGERS_REQUEST,
          actionTypes.CREATE_FLOW_TRIGGERS_SUCCESS,
          actionTypes.CREATE_FLOW_TRIGGERS_FAILURE,
        ],
        endpoint: `/flows/${flow_node_id}/links`,
        requestMethod: POST,
        payload,
      },
    });
  };
}
